import { Link, useLocation } from 'react-router-dom'
import { Compass } from 'lucide-react'

/**
 * The catch-all route. An unknown URL (a stale bookmark such as /cmbs) used to
 * match nothing inside Layout and render a black page with no navigation.
 */
export default function NotFound() {
  const { pathname } = useLocation()
  return (
    <div className="flex h-full w-full items-center justify-center p-8">
      <div className="max-w-md rounded-lg border border-amber-400/10 bg-black/30 px-6 py-5 text-center">
        <Compass size={18} className="mx-auto text-stone-600" />
        <p className="mt-3 text-[13px] font-medium text-stone-200">No screen at this address</p>
        <p className="mt-1.5 text-[11px] leading-relaxed text-stone-500">
          <span className="font-mono text-stone-400">{pathname}</span> is not a page in this platform.
          Use the navigation, or go to the{' '}
          <Link to="/" className="text-amber-300 hover:text-amber-200">
            start page
          </Link>
          .
        </p>
      </div>
    </div>
  )
}
